import { Box } from "@mui/material";
import CustomizedButton from "../../Custom/CustomizedButton";
import ModalUI from "../ModalUI";

const CopyConfirmation = ({
  openCopyConfirmation,
  copyConfirmationAction,
  closeConfirmationHandler,
}) => {
  return (
    <ModalUI
      title="ยืนยันการคัดลอก"
      open={openCopyConfirmation}
      handleClose={closeConfirmationHandler}
      maxWidth="sm"
    >
      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: "flex-end",
          gap: ".5rem",
        }}
      >
        <CustomizedButton
          title="ยกเลิก"
          variant="outlined"
          onClick={closeConfirmationHandler}
        />
        <CustomizedButton
          title="ยืนยัน"
          variant="contained"
          onClick={copyConfirmationAction}
        />
      </Box>
    </ModalUI>
  );
};

export default CopyConfirmation;
